export default function (Vue) {
  Vue.directive('tadaptive', {
    componentUpdated(el, { value = 0, arg }, vnode) {
      const { context } = vnode
      context.setMaxHeight = (function () {
        let timer = null
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(_ => {
            // debugger
            const { height: bodyHeight, width } = document.body.getBoundingClientRect()
            const elOffsetTop = el.offsetTop
            const nextDom = el.nextElementSibling
            const nextDomHeight = nextDom && nextDom.offsetHeight || 0
            const footerDom = document.querySelector('.el-footer')
            const footerHeight = footerDom && footerDom.offsetHeight || 0
            const maxHeight = bodyHeight - elOffsetTop - footerHeight - nextDomHeight - value
            if (arg) {
              context[arg] = width < 992 && maxHeight < 360 ? 360 : maxHeight
            } else {
              vnode.child.maxHeight = width < 992 && maxHeight < 360 ? 360 : maxHeight
            }
          }, 100)
        }
      })()
      context.setMaxHeight()
      window.addEventListener('resize', context.setMaxHeight)
    },
    unbind: function (el, binding, { context }) {
      window.removeEventListener('resize', context.setMaxHeight)
    }
  })
}